<template lang="pug">
  p
    b-icon(icon='question-circle', type="is-primary", size="is-small")
    |
    |
    a(href="#", @click.prevent="showModal") ライセンス証書番号の確認方法
</template>

<script>
const ModalCustomerCode = {
  template: `
    <div class="modal-card" id="modal-license-card">
      <header class="modal-card-head">
        <p class="modal-card-title">ライセンス証書番号の確認方法</p>
      </header>
      <section class="modal-card-body" id="modal-license-card-body">
        <iframe id="codeframe" src=` + process.env.DNLICENSE_POPUP_URL + `/license/neo.html></iframe>
      </section>
      <footer class="modal-card-foot"><button class="button" type="button" @click="$parent.close">OK</button></footer>
    </div>
  `,
  data () {
    return {
      image: require('@/assets/images/license-number.png')
    }
  }
}

export default {
  name: 'NoticeLicenseNumber',
  methods: {
    showModal () {
      this.$modal.open({
        component: ModalCustomerCode,
        hasModalCard: true
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/apps/com/NoticeLicenseNumber.vue